<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="
        $browserDetect && $browserDetect.isFirefox ? true : false
      "
      :preview-modal="false"
      :filename="
        'Industry Financial Profile - ' +
          (this.$route.path.includes('sample')
            ? 'sample'
            : this.$route.params.id)
      "
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="1150px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="afterDownload($event)"
      @hasGenerated="afterDownload($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content" class="pdf_docs prfl-pdf">
        <!-- <div class="pdf_docs prfl-pdf"> -->
        <section ref="page1" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page1" class="banner page">
            <div class="section_body">
              <img src="/img/pdf_logo.png" alt class="company_logo" />
              <h1>Industry Financial Profile</h1>
              <p class="sub-title-formatting">
                [{{ parseInt(this.headerInfo.bznaics) }}]
                {{ this.headerInfo.industry }}
              </p>
              <ul>
                <li>
                  Market Area:
                  <span>{{ this.headerInfo.area }}</span>
                </li>
                <li>
                  Sales Class:
                  <span>{{ this.headerInfo.sales_class }}</span>
                </li>
                <li>
                  Release Date:
                  <span>{{ releaseDisplay }}</span>
                </li>
              </ul>
              <div class="bottom_area">
                <div class="left">
                  <!--<h4>Company Name</h4>
                                        <div class="logo_wpr">
                                            <img src="/img/vivo_Energy.png" alt />
                                            <h3>Vivo Energy Ltd.</h3>
                                        </div>-->
                </div>
                <div v-if="this.headerInfo.developer_name" class="right">
                  <h5>Developed By</h5>
                  <h3>{{ this.headerInfo.developer_name }}</h3>
                </div>
              </div>
            </div>
            <div class="banner_footer">
              <!-- <h6>American Author</h6>-->
              <span class="author"><!--Joyce Meyer--> </span>
              <span class="date">{{
                moment(new Date()).format("MMM Do YYYY")
              }}</span>
            </div>
          </div>
        </section>
        <section ref="page2" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page2" class="company_info bg-grey page">
            <div class="section_body">
              <ul class="blue-crcl">
                <li>
                  <p>About the Data</p>
                  <p>Data Sources and Limitations</p>
                </li>
                <li>
                  <p>information</p>
                  <p>
                    Industry Peer Group <br />Industry In Context: The NAICS
                    Classification System <br />Ratio Categories
                  </p>
                </li>
                <li>
                  <h5>Financials</h5>
                  <p>
                    Income Statement <br />Balance Sheet <br />Sources &amp;
                    Uses of Funds
                  </p>
                </li>
                <li>
                  <h5>Ratios</h5>
                  <p>
                    Cash Flow-Slovency <br />Profitability <br />Efficiency
                    <br />Debt-Risk
                  </p>
                </li>
                <li>
                  <h5>Valuation Multiples</h5>
                  <p>
                    Sales Group: &#60; $2.5m <br />Sales Group: $2.5m - $24.9m
                    <br />Sales Group: &#62; $25m <br />Sales Group: All
                  </p>
                </li>
              </ul>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>
        <section ref="page3" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page3" class="about_info page">
            <div class="section_body">
              <div class="section_title">
                <h2>About the Data</h2>
                <span class="date">{{
                  moment(new Date()).format("MMM Do YYYY")
                }}</span>
              </div>
              <div class="negetive_margin">
                <div class="md-layout mt-4 mb-4">
                  <div class="md-layout-item md-size-40">
                    <div class="blue-box">
                      <span>Bizminer</span> data is widely accepted for industry
                      analytical work, benchmarking, valuations, forensics and
                      litigation. Bizminer content is accepted in US Tax Court
                      (Bauer vs. IRS: T.C. Memo. 2012-156) and is utilized by
                      state, provincial and national taxing agencies in the US
                      and Canada.
                    </div>
                  </div>
                  <div class="md-layout-item md-size-60 info-text">
                    <p>
                      Raw data analyzed for Bizminer reports is sourced from an
                      array of the nation's government and private statistical
                      sources. None of these raw data sources creates the final
                      measures reflected in Bizminer industry profiles. In
                      total, Bizminer accesses over a billion sourced data
                      points from 15 million business operations for each of its
                      twice annual updates covering a 3-5 year time series.
                      Historical data and Bizminer algorithms are used to inform
                      and test projections for non-reporting firms. Data
                      elements are sourced specifically from:
                    </p>

                    <p>
                      While 100% firm coverage is desirable for analysis
                      purposes, the greatest value of Bizminer reports rests in
                      discerning patterns of activity, which are reflected in
                      the large samples used to develop our reports. The overall
                      current coverage of the databases surpasses 13 million
                      active business operations at any point in time. As is the
                      case with any databases this large, some errors are
                      inevitable. Some firms are missed and specific information
                      on others is lacking from the database. Not all
                      information received is uniform or complete, resulting in
                      the need to develop projection algorithms for specific
                      industry segments and metrics in some report series. No
                      representation is made as to the accuracy of the databases
                      utilized or the results of subsequent analyses.
                    </p>
                  </div>
                </div>
              </div>
              <div class="list_box blue-tick">
                <ul>
                  <li>IRS SOI Corporation Tax Book</li>
                  <li>IRS Statistics of Income</li>
                  <li>US Economic Census</li>
                  <li>US Census Quarterly Financial Reports</li>
                  <li>US Census County Business Patterns</li>
                  <li>Bureau of Labor Statistics Monthly Employment Reports</li>
                  <li>
                    Bureau of Labor Statistics Monthly Unemployment Reports
                  </li>
                  <li>Bureau of Labor Statistics Annual Wage Survey</li>
                  <li>Bureau of Labor Statistics Industry Productivity</li>
                  <li>Reports</li>
                  <li>Bureau of Labor Statistics Price Indices</li>
                  <li>National Agricultural Statistical Service</li>
                  <li>US Census Quarterly Financial Reports</li>
                  <li>US Census Retail Trade Report</li>
                  <li>Data Axle</li>
                  <li>Business Valuation Resources (BVR)</li>
                  <li>Credit Reporting Agencies</li>
                  <li>Business Directories</li>
                  <li>American Community Survey</li>
                </ul>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>
        <section ref="page4" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page4" class="insight_sec page">
            <div class="section_body">
              <div class="section_title">
                <h2>Information</h2>
                <span class="date">{{
                  moment(new Date()).format("MMM Do YYYY")
                }}</span>
              </div>
              <div class="negetive_margin" v-if="chartInfo">
                <div class="md-layout md-alignment-bottom-center">
                  <div class="md-layout-item md-size-40">
                    <div class="table_sec change-sec mt-4">
                      <div class="tbl-title"><p>Industry Peer Group</p></div>
                      <md-table v-model="information.tableDataFirmsAnalyzed">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                          <md-table-cell
                            md-label="Profile Year"
                            md-sort-by="year"
                          >
                            {{ item.year }}
                          </md-table-cell>
                          <md-table-cell md-label="Firms">
                            {{ item.firms }}
                          </md-table-cell>
                        </md-table-row>
                      </md-table>
                    </div>
                  </div>
                  <div class="md-layout-item md-size-60 mt-4">
                    <div
                      v-if="
                        chartInfo &&
                          chartInfo !== {} &&
                          chartInfo.colouredLineChart &&
                          chartInfo.colouredLineChart.data.series[0]
                      "
                    >
                      <LineChart
                        :categories="chartInfo.colouredLineChart.data.labels"
                        :chartdata="chartData"
                      />
                    </div>
                  </div>
                  <div
                    class="md-layout-item md-medium-size-100 md-size-100 mt-4 pt-4 mb-4"
                  >
                    <div class="tbl-title blue-bg-title">
                      <h4>
                        Your Industry In Context: The NAICS Classification
                        System
                      </h4>
                    </div>
                    <div class="white_space p-4">
                      <p class="px-4">
                        The industry your selected fits within the official
                        NAICS (North American Industry Classification System)
                        and Bizminer’s proprietary taxonomy, which breaks out
                        more detailed industries classifications than NAICS by
                        adding up to eight decimal digits after the NAICS-6
                        code. The industry you selected fits into this industry
                        hierarchy:
                      </p>
                      <ul>
                        <li
                          v-for="(value, key) in information.naicsDrilldown"
                          :key="key"
                        >
                          NAICS: {{ key }} - {{ value }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>
        <section ref="page5" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page5" class="insight_sec page">
            <div class="section_body">
              <div class="md-layout terms bg-transparent p-0">
                <div class="md-layout-item md-size-100 p-0">
                  <div class="table_sec">
                    <div class="tbl-title blue-bg-title">
                      <h4>Ratio Categories</h4>
                    </div>
                    <p class="">
                      The Bizminer Industry Financial Priofile is based on
                      selected financial ratios that are typically considered to
                      be Key Performance Indicators (KPIs) which includes:
                    </p>
                  </div>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <p>Cash Flow/Solvency:</p>
                  <p>
                    Cash Flow ratios indicate a company’s ability to meet
                    various levels of demand on cash and easily obtainable cash
                    resources against current and anticipated near-term payments
                    due.
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Profitability:</h6>
                  <p>
                    Profitability ratios compare levels of return against
                    various expense and balance sheet components to measure your
                    performance against reasonable industry peer group
                    standards, indicating bottom line performance.
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Efficiency:</h6>
                  <p>
                    Efficiency ratios measure your success in marshalling
                    resources at hand to effectively manage various components
                    of your business operations. These indicators often point
                    most specifically toward actions that could enhance your
                    bottom line.
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Debt-Risk:</h6>
                  <p>
                    Debt-Risk ratios assess the appropriateness of a firm’s
                    level of debt against the ability to pay, as well as the
                    risk of insolvency.
                  </p>
                </div>
                <div class="md-layout-item md-size-33 box_data">
                  <h6>Profitability:</h6>
                  <p>
                    If you submit corresponding inputs, ratios will be scored
                    against industry values for the most recent three calendar
                    years.
                  </p>
                </div>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>
        <section ref="page6" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page6" class="industry_financials_sec">
            <!-- <div class="section_body"> -->
            <IFPdfIncomeStatement />
            <!-- </div> -->
          </div>
        </section>
        <section ref="page7" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page7" class="pl_definitions_sec page">
            <div class="section_body">
              <div class="section_title">
                <h2>Profit Loss Definitions</h2>
              </div>
              <div class="md-layout">
                <div class="md-layout-item md-size-50">
                  <p>
                    <b>Business Revenue</b> includes receipts from core business
                    operations. Interest Income and Other income (such as rents
                    and royalties) are generally detailed separately below
                    Operating Income. While Business Revenue is separated from
                    Interest Income for most classifications, Business Revenue
                    includes interest income from the private sector where it is
                    central to financial industry operations, including Finance
                    and Insurance (NAICS 52xxxx except NAICS 5242xx Insurance
                    Brokers and Other Insurance Activities); Real
                    Estate-Rental-Leasing (53xxxx); and Management of Companies
                    and Enterprises (55xxxxx).
                  </p>
                  <p>
                    <b>Cost of Sales</b> includes materials and labor involved
                    in the direct delivery of a product or service. Other costs
                    are included in the cost of sales to the extent that they
                    are involved in bringing goods to their location and
                    condition ready to be sold. Non-production overheads such as
                    development costs may be attributable to the cost of goods
                    sold. The costs of services provided will consist primarily
                    of personnel directly engaged in providing the service,
                    including supervisory personnel and attributable overhead.
                  </p>
                  <p>
                    <b>Cost of Sales-Labor:</b> The payroll compensation portion
                    of Cost of Sales, expressed as a per cent of Business
                    Revenue.
                  </p>
                  <p>
                    <b>Gross Margin</b> represents direct operating expenses
                    plus net profit. In addition to the labor portion of Cost of
                    Sales, payroll costs are reflected in the Officers
                    Compensation and Wages-Salary line items. In many cases,
                    SG&A (Sales, General and Administrative) costs also include
                    some overhead, administrative and supervisory wages.
                  </p>
                  <p>
                    <b>Officers Compensation:</b> Salary, wages stock bonuses
                    and other compensation paid to officers for personal
                    services rendered. It does not include qualified deferred
                    compensation, such as contributions to a 401(k) plan or a
                    salary reduction agreement, which are included in the
                    Benefits-Pensions line.
                  </p>
                  <p>
                    <b>Compensation and Wages-Salary</b> line items. In many
                    cases, SG&A (Sales, General and Administrative) costs also
                    include some overhead, administrative and supervisory wages.
                  </p>
                  <p>
                    <b>Rent</b> covers the rental cost of any business property,
                    including land, buildings and equipment.
                  </p>
                  <p>
                    <b>Benefits-Pension</b> includes, but is not limited to,
                    employee health care and retirement costs.
                  </p>
                </div>
                <div class="md-layout-item md-size-50">
                  <p>
                    The <b>Taxes Paid</b> line item includes payroll other
                    paid-in tax items, but not business income taxes due for the
                    period. Although it can be calculated in many ways and is
                    not a formal measure, the EBITDA line item (Earnings before
                    Interest Expense, income tax due, Depreciation and
                    Amortization) adds back interest payments, depreciation,
                    amortization and depletion allowances, and excludes income
                    taxes due to reduce the effect of accounting decisions on
                    the bottom line of the Profit and Loss Statement. Since some
                    firms utilize EBITDA to "add back" non-cash and flexible
                    expenses which may be altered through credits and accounting
                    procedures (such as income tax), paid-in income taxes from
                    the Taxes Paid line item are not added back in the EBITDA
                    calculation.
                  </p>
                  <p>
                    <b>Advertising</b> includes advertising, promotion and
                    publicity for the reporting business, but not on behalf of
                    others.
                  </p>
                  <p>
                    In addition to varying proportions of overhead,
                    administrative and supervisory wages, some generally more
                    minor expenses are aggregated under SG&A (<b
                      >Sales, General and Administrative</b
                    >).
                  </p>
                  <p>
                    <b>EBITDA:</b> Business Revenue: Earnings Before Interest,
                    (income) Taxes due, Depreciation and Amortization divided by
                    Business Revenue. EBITDA: Business Revenue is a relatively
                    controversial (and often criticized) metric designed to
                    eliminate the effect of finance and accounting decisions
                    when comparing companies and industry benchmarks. Tax
                    credits and deferral procedures and non-cash expenditures
                    (Amortization and Depreciation) are not deducted from the
                    profit equation, as are interest expenditures.
                  </p>
                  <p>
                    <b>Operating Expenses</b> sums the individual expense line
                    items above, yielding the Operating Income or net of core
                    business operations, when subtracted from the Gross Margin.
                  </p>
                  <p>
                    <b>Pre-Tax Net Profit</b> represents net profit before
                    income tax due. Income Tax calculates the federal corporate
                    tax rate before credits, leaving After-Tax Profit at the
                    bottom line.
                  </p>
                  <p>
                    <b>Discretionary Owner Earnings</b> sums Officer
                    Compensation, Depreciation and related non-cash expenses and
                    Net Profit before business taxes to represent a practical
                    measure of total return to owners. The D.O.E. metric is
                    mainly used for small businesses.
                  </p>
                </div>
              </div>
              <!-- <IFPdfSourcesUsers /> -->
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>
        <section ref="page8" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page8" class="industry_financials_sec">
            <!-- <div class="section_body"> -->
            <IFPdfBalanceSheet />
            <!-- </div> -->
          </div>
        </section>
        <section ref="page9" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page9" class="pl_definitions_sec page">
            <div class="section_body">
              <div class="section_title">
                <h2>Balance Sheet Definitions</h2>
              </div>
              <div class="md-layout">
                <div class="md-layout-item md-size-50">
                  <h4>
                    <b>Cash:</b> Money on hand in checking, savings or
                    redeemable certificate accounts.
                  </h4>
                  <h4>
                    <b>Receivables:</b> A short-term asset (to be collected
                    within one year) in the form of accounts or notes
                    receivable, and usually representing a credit for a
                    completed sale or loan.
                  </h4>
                  <h4><b>Inventory:</b> The stockpile of unsold products.</h4>
                  <h4>
                    <b>Current Assets:</b> The sum of a firm's cash, accounts
                    and notes receivable, inventory, prepaid expenses and
                    marketable securities which can be converted to cash within
                    a single operating cycle.
                  </h4>
                  <h4>
                    <b>Fixed Assets:</b> Long-term assets such as building and
                    machinery, net of accumulated
                    amortization-depreciation-depletion.
                  </h4>
                  <h4>
                    <b>Total Assets:</b> The sum of current assets and fixed
                    assets such as plant and equipment. Note: Some legacy year
                    asset line items are blended with the closest four-digit
                    industry segment. In local Industry Financial report, some
                    legacy year asset line item percentages are applied directly
                    from US averages for this industry. Local percentages may
                    differ. Other balance sheet percentages and all balance
                    sheet dollar calculations are based on actual local data.
                  </h4>
                </div>
                <div class="md-layout-item md-size-50">
                  <h4>
                    <b>Accounts Payable:</b> Invoices due to suppliers within
                    the current business cycle.
                  </h4>
                  <h4>
                    <b>Loans/Notes Payable:</b> Loan amounts due to suppliers
                    within the current business cycle.
                  </h4>
                  <h4>
                    <b>Current Liabilities:</b> Measurable debt owed within one
                    year, including accounts, loans and notes payable, accrued
                    liabilities and taxes due.
                  </h4>
                  <h4>
                    <b>Total Liabilities:</b> Current Liabilities plus Long Term
                    Liabilities such as notes and mortgages due over more than
                    one year.
                  </h4>
                  <h4>
                    <b>Long Term Liabilities:</b> which is due in more than one
                    year, including the portion of loans and mortgages that
                    become due after the current business cycle.
                  </h4>
                  <h4>
                    <b>Total Liabilities:</b> Current Liabilities plus Long Term
                    Liabilities such as notes and mortgages due over more than
                    one year.
                  </h4>
                  <h4>
                    <b>Net Worth:</b> Current assets plus fixed assets minus
                    current and long-term liabilities.
                  </h4>
                </div>
              </div>
              <!-- <IFPdfSourcesUsers /> -->
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>
        <section ref="page10" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page10" class="industry_financials_sec">
            <!-- <div class="section_body"> -->
            <IFPdfSourcesUsers />
            <!-- </div> -->
          </div>
        </section>
        <section ref="page11" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page11" class="industry_financials_sec">
            <!-- <div class="section_body"> -->
            <IFPdfRatios />
            <!-- </div> -->
          </div>
        </section>
        <!-- <section ref="page9" slot="pdf-content" class="pdf_docs prfl-pdf">
                     <div id="page9" class="pl_definitions_sec page">
                      <div class="section_body">
                        <div class="section_title">
                            <h2>Financial Ratio Definitions</h2>
                        </div>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-50">
                                <h4>
                                    <b>Cash:</b> Money on hand in checking, savings or redeemable certificate accounts.
                                </h4>
                                <h4>
                                    <b>Receivables:</b> A short-term asset (to be collected within one year) in the form of
                                    accounts or notes receivable, and usually representing a credit for a completed sale or
                                    loan.
                                </h4>
                                <h4>
                                    <b>Inventory:</b> The stockpile of unsold products.
                                </h4>
                                <h4>
                                    <b>Current Assets:</b> The sum of a firm's cash, accounts and notes receivable, inventory,
                                    prepaid expenses and marketable securities which can be converted to cash within a
                                    single operating cycle.
                                </h4>
                                <h4>
                                    <b>Fixed Assets:</b> Long-term assets such as building and machinery, net of accumulated
                                    amortization-depreciation-depletion.
                                </h4>
                                <h4>
                                    <b>Total Assets:</b> The sum of current assets and fixed assets such as plant and equipment.
                                    Note: Some legacy year asset line items are blended with the closest four-digit industry
                                    segment. In local Industry Financial report, some legacy year asset line item
                                    percentages are applied directly from US averages for this industry. Local percentages
                                    may differ. Other balance sheet percentages and all balance sheet dollar calculations
                                    are based on actual local data.
                                </h4>
                            </div>
                            <div class="md-layout-item md-size-50">
                                <h4>
                                    <b>Accounts Payable:</b> Invoices due to suppliers within the current business cycle.
                                </h4>
                                <h4>
                                    <b>Loans/Notes Payable:</b> Loan amounts due to suppliers within the current business cycle.
                                </h4>
                                <h4>
                                    <b>Current Liabilities:</b> Measurable debt owed within one year, including accounts, loans
                                    and notes payable, accrued liabilities and taxes due.
                                </h4>
                                <h4>
                                    <b>Total Liabilities:</b> Current Liabilities plus Long Term Liabilities such as notes and
                                    mortgages due over more than one year.
                                </h4>
                                <h4>
                                    <b>Long Term Liabilities:</b> which is due in more than one year, including the portion of
                                    loans and mortgages that become due after the current business cycle.
                                </h4>
                                <h4>
                                    <b>Total Liabilities:</b> Current Liabilities plus Long Term Liabilities such as notes and
                                    mortgages due over more than one year.
                                </h4>
                                <h4>
                                    <b>Net Worth:</b> Current assets plus fixed assets minus current and long-term liabilities.
                                </h4>
                            </div>
                        </div>
                      </div>
                      <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
                     </div>
                    </section> -->
        <section ref="page12" slot="pdf-content" class="pdf_docs prfl-pdf">
          <div id="page12" class="value_multiples page">
            <div class="section_body">
              <div class="section_title mb-4">
                <h2>Valuation Multiples</h2>
                <span class="date">{{
                  moment(new Date()).format("MMM Do YYYY")
                }}</span>
              </div>
              <div class="negetive_margin">
                <div class="md-layout mb-4">
                  <div class="md-layout-item md-size-100">
                    <h3 class="sub_header mt-4">About Valuation Multiples</h3>
                    <h4>
                      <!-- <b>Search results display up to six values in all:</b> Quartile
                                            1-Median-Quartile 3 multiples for each industry and sale group
                                            combination. You are only charged a search credit when an
                                            industry and sales group is selected and the industry multiple
                                            values are load on the page. Copy and paste into a file of your
                                            choosing to store.<br/><br/> -->
                      <b>Business Value Insight Terms:</b> The Bizminer
                      Valuations Value basis is derived from projected company
                      sales; peer group average earnings %; and industry
                      valuation multiples. Median ranges reflect a range of
                      market conditions and business performance at this revenue
                      scale.<br /><br />
                      You should not use Bizminer Valuations in place of a
                      professional valuation or as the basis of any specific
                      business-related or other financial transaction; nor to
                      secure a business or personal loan.<br /><br />
                      <b>Owner Earnings (Cash Flow) Approach:</b> Revenue/Owner
                      Earnings market valuation approach<br /><br />
                      <b>Sales Approach:</b> Revenue/Annual Sales market value
                      approach<br /><br />
                      <b>Note:</b> Median is the point at which 50% of a sample
                      is above and 50% of the same below the value. Quartile 1
                      lies at the mid-point between the median and the lowest
                      value; Quartile 3 between the median and the highest
                      value.
                    </h4>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <h5>Sales Group: &#60; $2.5m</h5>
                    <md-table v-model="tableInfo" table-header-color="blue">
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="">
                          <div class="md-table-side-label">
                            {{ item.name }}
                          </div>
                        </md-table-cell>
                        <md-table-cell md-label="Sales Multiples"
                          >{{ multiplesA[`Sales${item.id}`] }}
                        </md-table-cell>
                        <md-table-cell md-label="Earnings Multiples"
                          >{{ multiplesA[`Earnings${item.id}`] }}
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                  <div class="md-layout-item md-size-50">
                    <h5>Sales Group: $2.5m - $24.9m</h5>
                    <md-table v-model="tableInfo" table-header-color="blue">
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="">
                          <div class="md-table-side-label">
                            {{ item.name }}
                          </div>
                        </md-table-cell>
                        <md-table-cell md-label="Sales Multiples"
                          >{{ multiplesB[`Sales${item.id}`] }}
                        </md-table-cell>
                        <md-table-cell md-label="Earnings Multiples"
                          >{{ multiplesB[`Earnings${item.id}`] }}
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                  <div class="md-layout-item md-size-50 mt-4">
                    <h5>Sales Group: &#62; $25m</h5>
                    <md-table v-model="tableInfo" table-header-color="blue">
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="">
                          <div class="md-table-side-label">
                            {{ item.name }}
                          </div>
                        </md-table-cell>
                        <md-table-cell md-label="Sales Multiples"
                          >{{ multiplesC[`Sales${item.id}`] }}
                        </md-table-cell>
                        <md-table-cell md-label="Earnings Multiples"
                          >{{ multiplesC[`Earnings${item.id}`] }}
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                  <div class="md-layout-item md-size-50 mt-4">
                    <h5>Sales Group: All</h5>
                    <md-table v-model="tableInfo" table-header-color="blue">
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="">
                          <div class="md-table-side-label">
                            {{ item.name }}
                          </div>
                        </md-table-cell>
                        <md-table-cell md-label="Sales Multiples"
                          >{{ multiplesAll[`Sales${item.id}`] }}
                        </md-table-cell>
                        <md-table-cell md-label="Earnings Multiples"
                          >{{ multiplesAll[`Earnings${item.id}`] }}
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </div>
              </div>
            </div>
            <p class="common_footer footer-formatting">
              Copyright © 2022 Bizminer. All Rights Reserved.
            </p>
          </div>
        </section>

        <!-- </div> -->
      </section>
    </vue-html2pdf>
  </div>
</template>
<script>
import VueHtml2pdf from "vue-html2pdf";
// import domtoimage from "dom-to-image-more";
// import * as htmlToImage from 'html-to-image';
// import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
// import { ChartCard } from '@/components';
import IFPdfBalanceSheet from "./IFPdfBalanceSheet.vue";
import IFPdfIncomeStatement from "./IFPdfIncomeStatement.vue";
import IFPdfSourcesUsers from "./IFPdfSourcesUsers.vue";
import IFPdfRatios from "./IFPdfRatios.vue";
import LineChart from "@/components/LineChart.vue";
import moment from "moment";
import { mapState } from "vuex";

export default {
  methods: {
    reverseArray(a) {
      var rA = [];
      for (var i = a.length; i > 0; i--) {
        rA.push(a[i - 1]);
      }

      return rA;
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    onProgress($e) {},
    async beforeDownload({ html2pdf, options, pdfContent }) {
      // this.convertImages();

      let page1 = this.$refs.page1;
      let page2 = this.$refs.page2;
      let page3 = this.$refs.page3;
      let page4 = this.$refs.page4;
      let page5 = this.$refs.page5;
      let page6 = this.$refs.page6;
      let page7 = this.$refs.page7;
      let page8 = this.$refs.page8;
      let page9 = this.$refs.page9;
      let page10 = this.$refs.page10;
      let page11 = this.$refs.page11;
      let page12 = this.$refs.page12;

      let pages = [
        page1,
        page2,
        page3,
        page4,
        page5,
        page6,
        page7,
        page8,
        page9,
        page10,
        page11,
        page12,
      ];

      var worker = html2pdf()
        .set(options)
        .from(pages[0])
        .toPdf();
      pages.slice(1).forEach(function(page) {
        worker = worker
          .get("pdf")
          .then(function(pdf) {
            pdf.addPage();
          })
          .from(page)
          .toContainer()
          .toCanvas()
          .toPdf();
      });

      worker.get("pdf").then((pdf) => {
        if (this.$store.getters["user/pdfMustBeDownloaded"]) worker.save();
        else window.open(pdf.output("bloburl"), "_blank");
      });
    },
    async afterDownload() {
      this.$store.commit("user/SET_PDF_LOADING", false);
    },
    filterNode(node) {
      if (node instanceof Text) {
        return true;
      }
      return (
        [
          "div",
          "span",
          "p",
          "i",
          "strong",
          "main",
          "aside",
          "article",
          "pre",
          "code",
          "time",
          "address",
          "header",
          "footer",
        ].includes(node.tagName.toLowerCase()) ||
        /^h[123456]$/i.test(node.tagName)
      );
    },
    convertImages() {},
  },
  components: {
    VueHtml2pdf,
    // ChartCard,
    IFPdfIncomeStatement,
    IFPdfBalanceSheet,
    IFPdfSourcesUsers,
    IFPdfRatios,
    LineChart,
  },
  props: ["headerInfo", "information", "valMultiples"],
  data() {
    return {
      tableInfo: [
        {
          id: "Low",
          name: "Q1",
        },
        {
          id: "Med",
          name: "Median",
        },
        {
          id: "High",
          name: "Q3",
        },
      ],
      chartInfo: false,
      chartLoaded: false,
      xaxis: {
        labels: {
          style: {
            colors: ["#FFFFFF"],
          },
        },
      },
      moment: moment,
    };
  },
  computed: {
    ...mapState({
      multiplesA: (state) => {
        return state.user.profile["multiples_A"]
          ? state.user.profile["multiples_A"]
          : [];
      },
      multiplesB: (state) => {
        return state.user.profile["multiples_B"]
          ? state.user.profile["multiples_B"]
          : [];
      },
      multiplesC: (state) => {
        return state.user.profile["multiples_C"]
          ? state.user.profile["multiples_C"]
          : [];
      },
      multiplesAll: (state) => {
        return state.user.profile["multiples_all"]
          ? state.user.profile["multiples_all"]
          : [];
      },
      profile: (state) => state.user.profile,
      releaseDisplay: (state) =>
        state?.user?.profile?.release_display
          ? state?.user?.profile?.release_display.replace("-", " ")
          : "",
    }),
    user() {
      return this.$store.state.user.user;
    },
    pdfDownloadSetting() {
      return this.user &&
        this.user.preferences &&
        this.user.preferences.defaultPDFDownload
        ? this.user.preferences.defaultPDFDownload
        : "_blank";
    },
    chartData() {
      return [
        {
          name: "series-1",
          data: this.reverseArray(
            this.chartInfo.colouredLineChart.data.series[0]
          ),
        },
      ];
    },
  },
  watch: {
    information: function(newVal, oldVal) {
      // watch it
      this.chartLoaded = true;
      this.chartInfo = newVal;
    },
  },
};
</script>
